import { render } from "./OrderReceiptComponent.vue?vue&type=template&id=bc404448"
import script from "./OrderReceiptComponent.vue?vue&type=script&lang=js"
export * from "./OrderReceiptComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/OrderReceiptComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc404448"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc404448', __exports__)) {
    api.reload('bc404448', __exports__)
  }
  
  module.hot.accept("./OrderReceiptComponent.vue?vue&type=template&id=bc404448", () => {
    api.rerender('bc404448', render)
  })

}


export default __exports__